import React from "react";

const CloseXIcon = ({name, color, size}) => (
    <svg viewBox="0 0 32 32" className={`icon icon-${name}`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M.5 3.715L3.83.5 31.5 28.285 28.285 31.5.5 3.715z" />
        <path d="M.5 28.285L28.285.5 31.5 3.715 3.83 31.5.5 28.285z" />
    </svg>
);

export default CloseXIcon;